import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Building2, ShieldCheck, Award, Users, ArrowRight } from "lucide-react";

export default function About() {
  return (
    <main className="bg-ink min-h-screen pt-32 pb-16">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <p className="text-brand-500 font-medium mb-2">About us</p>
            <h1 className="font-display text-4xl md:text-5xl font-bold text-neutral-900 leading-tight" data-testid="about-heading">
              Building durable spaces, blending design with engineering.
            </h1>
            <p className="text-neutral-500 mt-5 leading-relaxed">
              my Property Pune is a Pune-focused real estate platform helping buyers,
              tenants, owners and agents connect with the right property. From verified
              flats and houses to commercial spaces, we bring detailed, honest project
              information to every listing.
            </p>
            <p className="text-neutral-500 mt-4 leading-relaxed">
              Alongside listings, we also assist with construction and renovation needs —
              invisible safety grills, RCC & structural work, tiling, plumbing, painting
              and carpentry — through our trusted partner network.
            </p>
            <Link to="/services" className="inline-flex items-center gap-2 mt-6 px-6 py-3 bg-neutral-900 text-white font-semibold rounded-full hover:bg-brand-500 transition-colors">
              Explore our services <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
          <motion.div initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.5 }}>
            <img src="/hero_construction_bg.png" alt="my Property Pune" className="rounded-3xl shadow-card w-full object-cover h-[420px]" />
          </motion.div>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4 mt-16">
          {[
            { icon: Building2, title: "Turnkey Projects", desc: "End-to-end construction & renovation under one roof." },
            { icon: ShieldCheck, title: "Safety First", desc: "High-tensile invisible grills & compliant work." },
            { icon: Award, title: "Premium Quality", desc: "Durable materials and precise finishing." },
            { icon: Users, title: "Trusted in Pune", desc: "Local expertise you can rely on." },
          ].map((f) => (
            <div key={f.title} className="bg-surface border border-neutral-200 rounded-2xl p-6 shadow-card">
              <f.icon className="w-8 h-8 text-brand-500 mb-3" />
              <h3 className="font-semibold text-neutral-900 mb-1">{f.title}</h3>
              <p className="text-neutral-500 text-sm">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
}
